@for (config of buttonsConfig; track $index; let i = $index; let last = $last) {
    <wdx-radio-button
        [label]="config.label | translateTokenisedString"
        [icon]="config.icon"
        [disabled]="disabled"
        [value]="config.value"
        [checked]="config.value === checkedValue"
        [size]="size"
        (click)="selected(config.value)"
        [class.me-1]="!last"
    ></wdx-radio-button>
}
